import { createStyles, makeStyles } from '@mui/styles';
import { Colors } from '../../../layout/theme-next';
import { NextTheme } from '../../../layout/theme-next/provider';

export const styles = makeStyles<NextTheme>((theme) =>
  createStyles({
    root: {
      overflow: 'auto',
    },
    grid: {
      marginTop: theme.spacing(0.5),
    },
    submitButton: {
      '&:hover': {
        backgroundColor: Colors.darkBluish,
      },
    },
  }),
);
